import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { URL_API } from 'src/app/tools/URL';
import { FiltroPesquisaDemandaDTO } from 'src/app/entity/FiltroPesquisaDemandaDTO';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/app/environment';
import { MANIFESTO_ENUM } from 'src/app/tools/Manifestos';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManifestoService {

  listaManifesto = [];

  constructor(private rest: RestService, private http: HttpClient) { }

  carregarDados() {
    return this.rest.get(`${URL_API.PATH_MANIFESTO_CARREGAR}`).pipe(
      map((manifestos: any[]) => manifestos.filter(manifesto => this.isManifestoDisponivelNoFront(manifesto)))
    );
  }

  private isManifestoDisponivelNoFront(manifesto: any): boolean {
    const idManifesto = Number(manifesto && manifesto.id);
    return Object.keys(MANIFESTO_ENUM).some(key => Number(MANIFESTO_ENUM[key].id) === idManifesto);
  }

  filtrarDemandas(filtro: FiltroPesquisaDemandaDTO) {

    return this.rest.post(`${URL_API.PATH_FILTRAR_MANIFESTOS}`, filtro);

  }

  filtrarDemandasUsuario(filtro: FiltroPesquisaDemandaDTO) {

    return this.rest.post(`${URL_API.PATH_FILTRAR_MANIFESTOS_USUARIO}`, filtro);

  }

  salvarResposta(resposta) {

    const headers = new HttpHeaders().set('Content-Type', 'application/json;');

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_MANIFESTO_RESPOSTA}`, resposta, { headers, responseType: 'text'});

  }

  statusFindAll() {

    return this.rest.get(`${URL_API.PATH_MANIFESTO_STATUS}`);

  }

  excluirRascunho(id: number | string, manifestoSelecionado: any) {
    // remove leading slash caso exista e garanta valor seguro
    let tipoManifesto = manifestoSelecionado && manifestoSelecionado.path ? (manifestoSelecionado.path + '').replace(/^\//, '') : '';

    // envia tipoManifesto como query parameter para que o backend saiba qual tipo está sendo excluído
    let tipoParam = tipoManifesto ? `${encodeURIComponent(tipoManifesto)}` : '';
    if(tipoParam === 'fale-com-rh'){
      console.log('entrou');
      tipoParam = 'fale_com_rh';
    }
    console.log(tipoParam);

    return this.rest.delete(`${URL_API.PATH_MANIFESTO_EXCLUIR}/${id}/${tipoParam}`);
  }

}
